import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 opacity-50" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-hidden" }
const _hoisted_3 = { class: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h-full w-1 transition group-hover:bg-gray-400" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex h-full flex-col flex-1 overflow-y-auto bg-white py-6 shadow-xl" }
const _hoisted_7 = { class: "px-4 sm:px-6" }
const _hoisted_8 = { class: "flex items-start justify-between" }
const _hoisted_9 = { class: "ml-3 flex h-7 items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1)
const _hoisted_11 = { class: "relative flex-1 px-4 sm:px-6" }

import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";
import { useDraggable, useWindowSize } from "@vueuse/core";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SlideOver',
  props: {
  open: {
    type: Boolean,
    default: false,
  },
  maxWidth: {
    type: String,
    default: "40vw",
  },
},
  emits: ["closed"],
  setup(__props) {

const slider = ref<HTMLElement | null>(null);

const { x: sliderPosition } = useDraggable(slider);
const { width: windowWidth } = useWindowSize();





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "div",
    show: !!__props.open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-40",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closed')))
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transform transition ease-in-out duration-200 sm:duration-200",
                "enter-from": "translate-x-full",
                "enter-to": "translate-x-0",
                leave: "transform transition ease-in-out duration-200 sm:duration-200",
                "leave-from": "translate-x-0",
                "leave-to": "translate-x-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass(['pointer-events-auto flex min-w-[350px]']),
                    style: _normalizeStyle({
                width: _unref(sliderPosition) ? `${_unref(windowWidth) - _unref(sliderPosition)}px` : '600px',
                maxWidth: __props.maxWidth,
              })
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "w-5 flex justify-center items-center -mr-2.5 z-10 group cursor-[col-resize] relative",
                        ref_key: "slider",
                        ref: slider
                      }, _hoisted_5, 512),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_unref(DialogTitle), { class: "leading-6 text-gray-900 text-sm" }, {
                              default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "title")
                              ]),
                              _: 3
                            }),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "rounded-md bg-white text-gray-400 hover:text-yellow outline-none",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
                              }, [
                                _hoisted_10,
                                _createVNode(_unref(XMarkIcon), {
                                  class: "h-6 w-6",
                                  "aria-hidden": "true"
                                })
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _renderSlot(_ctx.$slots, "content")
                        ])
                      ])
                    ]),
                    _: 3
                  }, 8, ["style"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})